import React, { Component } from 'react';
import './App.css';
import Center from './Center';
import FurnishedLiving from './FurnishedLiving';
import HalfScreenTextParent from './HalfScreenTextParent';
import CenteredTextTest from './CenteredTextTest';
import Fade from 'react-reveal/Fade';
import TiArrowRight from 'react-icons/lib/ti/arrow-right';
import IoIosCheckmarkOutline from 'react-icons/lib/io/ios-checkmark-outline';

import FlexCenter from './FlexCenter';
import rightarrow from './rightarrow.png';
import axios from 'axios';
import Modal from 'react-modal';

var Spinner = require('react-spinkit');



class FormInput extends Component {
  constructor(){
    super()
    this.state = {
      titleUp: false
    }
  }
  render(){
    var t = this, s = this.state, p = this.props;

    return (
      <div className="cf-item">
        <div style={{position: 'absolute'}}>
          <span style={{position: 'absolute'}} className={s.titleUp === true ? "upped" : "downed"}>{p.title}</span>
        </div>
        <input id={p.propsId} onChange={(e) => p.print(p.propsId, e.target.value)} value={p.valueHolder} style={{fontSize: '14px'}} onFocus={() => t.setState({titleUp: true})} onBlur={(e) => {if(!e.target.value){t.setState({titleUp: false})}}}></input>
      </div>
    )
  }
}

class TextAreaInput extends Component {
  constructor(){
    super()
    this.state = {
      titleUp: false
    }
  }
  render(){
    var t = this, s = this.state, p = this.props;

    return (
      <div className="cf-message">
        <span style={{position: 'absolute'}} className={s.titleUp === true ? "upped" : "downed"}>{p.title}</span>
          <textarea id="message"
            value={p.message}
            onChange={(e) => p.print('message', e.target.value)}
            onFocus={() => t.setState({titleUp: true})}
            onBlur={(e) => {if(!e.target.value){t.setState({titleUp: false})}}}
            ></textarea>
      </div>
    )
  }
}

class Form extends Component {
  constructor(){
    super();

    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      pleaseEnterAllFields: '',
      showSuccessfulMessage: '',
      message: '',
      months: '',
      country: '',
      spinnerStatus: 'hideSpinner',
      btnDisabled: false,
      modalIsOpen: false,
      errorModalOpen: false
    }

    this.baseState = this.state;

    this.print = this.print.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.openModal = this.openModal.bind(this);
    this.openErrorModal = this.openErrorModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  openErrorModal() {
    this.setState({errorModalOpen: true});
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    // this.setState({modalIsOpen: false});
    this.setState(this.baseState);
  }

  closeErrorModal() {
    // this.setState({modalIsOpen: false});
    this.setState(this.baseState);
  }

  submitForm(){
    var t = this, s = this.state;
    this.setState({spinnerStatus: 'showSpinner', btnDisabled: true});

    var firstName = document.getElementById("firstName").value;
    var lastName = document.getElementById("lastName").value;
    var email = document.getElementById("email").value;
    var phone = document.getElementById("phone").value;
    var months = document.getElementById("months").value;
    var country = document.getElementById("country").value;
    var message = document.getElementById("message").value;
    var test = function(x){

    }


    var formObj = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      months: months,
      country: country,
      message: message
    }

    //check to see if each form value is valid
    var counter = 0;
    for(var key in formObj){
      //console.log(key, formObj[key])
      if (!formObj[key]){
        this.setState({pleaseEnterAllFields: true, spinnerStatus: 'hideSpinner'});
        // console.log("pleaseEnterAllFields", s.pleaseEnterAllFields)
      } else {
        counter += 1;
        // console.log("counter", counter);
      }
    }

    //console.log('counter:', counter);

    //if all are true
    if(counter === 7) {
      this.setState({pleaseEnterAllFields: false});
      // submit post request using axios
      console.log('object to send: ', formObj);
      const request = axios.post('https://furn-liv-la-0718.herokuapp.com/contact', formObj);
      
      request.then((result)=>{
        console.log("request = ", result);
        this.setState({modalIsOpen: true, spinnerStatus: 'hideSpinner'});
      }).catch(function (error) {
        console.log("error !!!", error);
        t.setState({errorModalOpen: true, spinnerStatus: 'hideSpinner'});
      });
    } else {
      return;
    }


  }

  print(x, y){
    // console.log(x, y)
    var state = {...this.state};
    state[x] = y;
    this.setState(state);
  }

  render(){
    var t = this, s = this.state;
    // console.log(s);
    var requiredMessages = function(){return s.pleaseEnterAllFields ? "show-enter-all-fields" :  "hide-enter-all-fields";}();
    var messageComplete = function(){return s.showSuccessfulMessage ? "show-success" : "hide-success";}();
    // console.log('show succesful message', s.showSuccessfulMessage)
    var contentObj = furnishedLivingObj;

    const customStyles = {
      content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)',
        width                 : '400px',
        textAlign             : 'center',
        padding               : '25px',
      }
    };


    return (
      <div className="contact-form" style={{display: 'inline-block'}}>
        <form id="contact-form">
          <div className="contact-flex-wrap" style={{display: 'flex'}}>
            <FormInput propsId={"firstName"} valueHolder={s.firstName} print={t.print} title={"First Name"} />
            <FormInput propsId={"lastName"} valueHolder={s.lastName} print={t.print} title={"Last Name"} />
          </div>
          <div className="contact-flex-wrap" style={{display: 'flex'}}>
            <FormInput propsId={"email"} valueHolder={s.email} print={t.print} title={"Email"} />
            <FormInput propsId={"phone"} valueHolder={s.phone} print={t.print} title={"Phone"} />
          </div>
          <div className="contact-flex-wrap" style={{display: 'flex'}}>
            <FormInput propsId={"months"} valueHolder={s.months} print={t.print} title={"Months Staying"} />
            <FormInput propsId={"country"} valueHolder={s.country} print={t.print} title={"Visiting From"} />
          </div>
          <TextAreaInput print={t.print} title={"Message"} />
          <div className="required-messages">
            <div style={{textAlign: 'center'}} className={requiredMessages}>All fields are required.</div>
          </div>
          <div className="flex-container">
              <Fade bottom>
                  <div className="furnishedLivingBtnContainer">
                    <div onClick={this.submitForm} disabled={s.btnDisabled} className="furnishedLivingBtn" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
                        <p>{contentObj.buttonText}</p>
                        <div className='fp-arrows-container' style={{width: '40px', overflow: 'hidden', display: 'flex'}}>
                          <div className="fp-left-arrow"><img style={{width: '17px'}} src={rightarrow}/></div>
                          <div className="fp-right-arrow" style={{marginLeft: '35px'}}><img style={{width: '17px'}} src={rightarrow} alt="Submit Form Button"/></div>
                        </div>
                    </div>
                  </div>
              </Fade>
              <Spinner
                className={'formSpinner ' + this.state.spinnerStatus}
                fadeIn="none"
                name="ball-beat"
                color="#333030"/>
              <Modal
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={customStyles}
                contentLabel="Example Modal">
                <div><IoIosCheckmarkOutline className="checkFontModal" /></div>
                <div className="modalHeadingContainer">Thank you!</div>
                <div className="modalTextContainer">We've received your message and will respond within 24-48 hours, if not sooner. Feel free to leave us an email at info@furnishedlivingla.com or by phone at (424) 258-4690.</div>
                <button className="modalCloseBtn" onClick={this.closeModal}>close</button>
              </Modal>
              <Modal
                isOpen={this.state.errorModalOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeErrorModal}
                style={customStyles}
                contentLabel="Example Modal">
                <div><IoIosCheckmarkOutline className="checkFontModal" /></div>
                <div className="modalHeadingContainer">I'm Sorry.</div>
                <div className="modalTextContainer">We seem to be having technical difficiulties with your request. Please feel free to leave us an email at info@furnishedlivingla.com or by phone at (424) 258-4690. We're sorry for the inconvenience.</div>
                <button className="modalCloseBtn" onClick={this.closeErrorModal}>close</button>
              </Modal>
          </div>


          <div>
            {/*<div className={messageComplete}>Thank you for your message! We will respond soon.</div>*/}
          </div>
        </form>
      </div>
    );
  }
}

export default Form;

var furnishedLivingObj = {
  title: 'Get In Touch',
  text1: 'You can always reach us by email at info@richersresidences.com. We will respond in 24-48 hours. Our phone humber is this what else do you want say here.' ,
  text2: 'Our furnished units are located in walking distance to anything you may need. In West Hollywood, we are just off Robertson, and in Santa Monica we are steps from the beach on Montana Ave. This is further dummy information that CLIENT may want to put here.',
  buttonText: 'Send Message'
}



/*



*/



// WEBPACK FOOTER //
// ./src/FormInput.js